import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { PublicLayout } from "./components/Layout";
import { HomePage } from "./pages/Home";
import { ConsultingPage } from "./pages/Consulting";
import { RegionalServicesPage, ServicesHubPage } from "./pages/Services";
import { PricingPage } from "./pages/Pricing";
import { ResourcesPage, ResourceDetailPage } from "./pages/Resources";
import { ReportsPage } from "./pages/Reports";
import { ContactPage } from "./pages/Contact";
import { EquipmentPage, EquipmentProductPage } from "./pages/Equipment";
import { LoginPage, RegisterPage, MagicPage } from "./pages/Auth";
import {
  DashboardHome,
  DashboardLibrary,
  DashboardReports,
  DashboardReportDetail,
  DashboardBilling,
  DashboardProfile,
  RequireAuth,
} from "./pages/Dashboard";
import {
  AdminHome,
  AdminSubmissions,
  AdminSubmissionDetail,
  AdminResources,
  AdminEnquiries,
  AdminClients,
  AdminDocumentRegister,
  AdminDocumentRegisterDetail,
} from "./pages/Admin";
import {
  InsightsPage,
  TrackRecordPage,
  PrivacyPage,
  TermsPage,
  ProfessionalResponsibilityPage,
  NotFoundPage,
} from "./pages/StaticPages";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="consulting" element={<ConsultingPage />} />
            <Route path="services" element={<ServicesHubPage />} />
            <Route path="au/services" element={<RegionalServicesPage region="au" />} />
            <Route path="sg/services" element={<RegionalServicesPage region="sg" />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="resources/:slug" element={<ResourceDetailPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="equipment" element={<EquipmentPage />} />
            <Route path="equipment/:slug" element={<EquipmentProductPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="track-record" element={<TrackRecordPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="professional-responsibility" element={<ProfessionalResponsibilityPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="auth/magic" element={<MagicPage />} />

            <Route
              path="dashboard"
              element={
                <RequireAuth>
                  <DashboardHome />
                </RequireAuth>
              }
            />
            <Route
              path="dashboard/library"
              element={
                <RequireAuth>
                  <DashboardLibrary />
                </RequireAuth>
              }
            />
            <Route
              path="dashboard/reports"
              element={
                <RequireAuth>
                  <DashboardReports />
                </RequireAuth>
              }
            />
            <Route
              path="dashboard/reports/:id"
              element={
                <RequireAuth>
                  <DashboardReportDetail />
                </RequireAuth>
              }
            />
            <Route
              path="dashboard/billing"
              element={
                <RequireAuth>
                  <DashboardBilling />
                </RequireAuth>
              }
            />
            <Route
              path="dashboard/profile"
              element={
                <RequireAuth>
                  <DashboardProfile />
                </RequireAuth>
              }
            />

            <Route path="admin" element={<AdminHome />} />
            <Route path="admin/submissions" element={<AdminSubmissions />} />
            <Route path="admin/submissions/:id" element={<AdminSubmissionDetail />} />
            <Route path="admin/resources" element={<AdminResources />} />
            <Route path="admin/document-register" element={<AdminDocumentRegister />} />
            <Route path="admin/document-register/:id" element={<AdminDocumentRegisterDetail />} />
            <Route path="admin/enquiries" element={<AdminEnquiries />} />
            <Route path="admin/clients" element={<AdminClients />} />

            <Route path="home" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
